export default __webpack_public_path__ + "a78c2dca5b5c9a0844eb7738cf02894e.png";